/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ------------------------------------------------------------------
   * Wue — variant-aware personalisation field
   *
   * The personalisation inputs are rendered in snippets/product.liquid from
   * PRODUCT TAGS (P12, P10, P8, P40, Engraved, Roman, Initials, Monogram,
   * Year). That is a page-render decision, so the box currently shows on
   * every variant of every tagged product — and 117 of 140 active products
   * carry P12, so it shows almost everywhere.
   *
   * This script layers the variant on top, without touching the 126KB
   * product snippet:
   *
   *   - Shows the field only when the selected variant has an option value
   *     beginning with "yes" (the old range: "yes please - hand stamp...",
   *     "yes (+£3) - please add...", etc) or exactly "Custom Message" (the
   *     By Wue range's card option, +£3, 80 characters).
   *   - Builds that field for the By Wue range, which the tag-driven snippet
   *     does not render at all.
   *   - Products with no such option anywhere (Postcode Coaster, the tie
   *     clips, the personalised luggage tag) always show it, as now.
   *   - Makes the field required while visible, and blocks add-to-cart when
   *     it is blank — no more unfulfillable orders.
   *   - Clears the value when hiding, so a typed name cannot ride along on a
   *     "no thanks" variant.
   *   - Corrects maxlength: the P10 and P8 branches in the theme both
   *     hardcode maxlength="12" while their labels promise 10 and 8.
   *   - Applies the most specific tag rather than the first one found, which
   *     fixes Thank You Bridesmaid Heart Bracelet (tagged both P10 and P12).
   * ------------------------------------------------------------------ */

  var PERSONALISATION_PROPS = [
    'Personalisation', 'day', 'month', 'year', 'initials', 'Monogram'
  ];

  // Most specific first — the theme's if/elsif chain tests P12 first, which
  // is wrong given how widely P12 is applied.
  var TAG_RULES = [
    { tag: 'Engraved', max: 12, label: 'Engraving' },
    { tag: 'P40',      max: 40, label: 'Personalisation' },
    { tag: 'P10',      max: 10, label: 'Personalisation' },
    { tag: 'P8',       max: 8,  label: 'Personalisation' },
    { tag: 'P12',      max: 12, label: 'Personalisation' }
  ];

  var ERROR_TEXT = 'Please add your personalisation before adding to bag.';
  var CUSTOM_CARD_ERROR_TEXT = 'Please add your message before adding to bag.';

  var CUSTOM_CARD_VALUE = 'custom message';

  // The old range toggles personalisation with an option value beginning
  // "yes" ("yes please - hand stamp my gift box (+£3)" and the rest). The By
  // Wue range uses a card option whose custom value is exactly
  // "Custom Message" (+£3, 80 characters). Both ranges are live at the same
  // time, so match either.
  function isCustomCardValue(value) {
    var v = String(value == null ? '' : value).trim().toLowerCase();
    return v.indexOf('yes') === 0 || v === CUSTOM_CARD_VALUE;
  }

  function isNewRangeCard(value) {
    return String(value == null ? '' : value).trim().toLowerCase() === CUSTOM_CARD_VALUE;
  }

  // The By Wue products carry the P80 card tag, which snippets/product.liquid
  // knows nothing about — its if/elsif chain only renders an input for P12,
  // P10, P8, P40, Engraved, Roman, Initials, Monogram and Year. Rather than
  // rewrite the 126KB snippet, build the one field the new range needs and
  // put it in the form; everything below then treats it like any other.
  function buildCustomMessageField(form) {
    var wrapper = document.createElement('div');
    wrapper.className = 'line-item-property__field';

    var label = document.createElement('label');
    label.className = 'pName';
    label.setAttribute('for', 'wue-custom-message');
    label.textContent = 'Your custom message';

    var input = document.createElement('input');
    input.className = 'pBox';
    input.type = 'text';
    input.id = 'wue-custom-message';
    input.name = 'properties[Personalisation]';
    input.setAttribute('maxlength', '80');

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.textContent = 'Enter your message (maximum 80 characters).';
    help.style.display = 'block';

    wrapper.appendChild(label);
    wrapper.appendChild(document.createElement('br'));
    wrapper.appendChild(input);
    wrapper.appendChild(help);

    var addButton = form.querySelector('[name="add"], [data-add-to-cart]');
    var anchor = addButton
      ? (addButton.parentNode === form ? addButton : addButton.closest('form > *'))
      : null;
    if (anchor && anchor.parentNode === form) {
      form.insertBefore(wrapper, anchor);
    } else {
      form.appendChild(wrapper);
    }
    return input;
  }

  function variantOptionValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3];
  }

  function initProduct(container) {
    var jsonEl = container.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var form = container.querySelector('form[data-product-form]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;

    // Collect only the inputs this theme uses for personalisation. Scoping by
    // name keeps us clear of the gift-card recipient form, which also writes
    // line item properties.
    var inputs = [];
    PERSONALISATION_PROPS.forEach(function (prop) {
      var input = form.querySelector('input[name="properties[' + prop + ']"]');
      if (input) inputs.push(input);
    });
    var offersCustomCard = product.variants.some(function (variant) {
      return variantOptionValues(variant).some(isNewRangeCard);
    });

    if (!inputs.length) {
      if (!offersCustomCard) return;
      inputs.push(buildCustomMessageField(form));
    }

    var wrappers = [];
    inputs.forEach(function (input) {
      var wrapper = input.closest('.line-item-property__field') || input.parentNode;
      if (wrapper && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    });
    if (!wrappers.length) return;

    // --- Correct the max length and label from the most specific tag -------
    var tags = (product.tags || []).map(function (t) { return String(t); });
    var rule = null;
    for (var i = 0; i < TAG_RULES.length; i++) {
      if (tags.indexOf(TAG_RULES[i].tag) !== -1) { rule = TAG_RULES[i]; break; }
    }

    var mainInput = form.querySelector('input[name="properties[Personalisation]"]');
    if (rule && mainInput) {
      mainInput.setAttribute('maxlength', String(rule.max));
      var label = (mainInput.closest('.line-item-property__field') || form)
        .querySelector('label');
      if (label) {
        label.textContent = rule.label + ' (max ' + rule.max + ' characters)';
      }
    }

    // --- Work out which variants should show the field --------------------
    var hasToggle = product.variants.some(function (variant) {
      return variantOptionValues(variant).some(isCustomCardValue);
    });

    var allowed = {};
    product.variants.forEach(function (variant) {
      var show = hasToggle
        ? variantOptionValues(variant).some(isCustomCardValue)
        : true;
      if (show) allowed[String(variant.id)] = true;
    });

    // Nothing to do if the field should always be visible.
    var alwaysVisible = !hasToggle;

    // --- Error message ----------------------------------------------------
    var error = document.createElement('small');
    error.className = 'pError';
    error.textContent = offersCustomCard ? CUSTOM_CARD_ERROR_TEXT : ERROR_TEXT;
    error.style.display = 'none';
    error.style.color = '#b00020';
    error.style.marginTop = '6px';
    error.style.fontSize = '0.85em';
    wrappers[wrappers.length - 1].appendChild(error);

    function setVisible(show) {
      wrappers.forEach(function (wrapper) {
        wrapper.style.display = show ? '' : 'none';
        wrapper.hidden = !show;
      });
      inputs.forEach(function (input) {
        // required must come off while hidden, or the browser refuses to
        // submit a form containing an invalid control it cannot focus
        input.required = show;
        if (!show) input.value = '';
      });
      if (!show) error.style.display = 'none';
    }

    function sync() {
      setVisible(alwaysVisible || allowed[String(idInput.value)] === true);
    }

    function validate(event) {
      if (inputs[0].required !== true) return;
      var empty = inputs.some(function (input) { return input.value.trim() === ''; });
      if (!empty) { error.style.display = 'none'; return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      error.style.display = 'block';
      inputs[0].focus();
    }

    // Radio and swatch selectors fire a native change event.
    form.addEventListener('change', function () { setTimeout(sync, 0); });

    // The popout selector writes the hidden variant id from JS. Watch the
    // attribute in case it is set that way...
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(idInput, {
        attributes: true, attributeFilter: ['value']
      });
    }

    // ...and poll, because assigning .value from JS changes the property and
    // not the attribute, which the observer above would miss.
    var last = idInput.value;
    setInterval(function () {
      if (idInput.value !== last) { last = idInput.value; sync(); }
    }, 250);

    form.addEventListener('submit', validate, true);
    var addButton = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addButton) addButton.addEventListener('click', validate, true);

    sync();
  }

  function init() {
    var containers = document.querySelectorAll('[data-product]');
    for (var i = 0; i < containers.length; i++) {
      try {
        initProduct(containers[i]);
      } catch (e) {
        if (window.console && console.warn) {
          console.warn('[Wue personalisation]', e);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
